<template>
  <div class="lp-range-bool-container">
    <div class="range-bar" :style="barStyle" @click.stop.prevent="toggleVal">
      <div class="range-pointer" :style="pointerStyle" @click.stop.prevent="toggleVal"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'active', 'val' ],
  created() {
    if ( this.active !== undefined ) this.isActive = this.active;
    if ( this.val !== undefined ) this.value = this.val;
  },
  data() {
    return {
      isActive: true,   // 활성화 여부
      value: true       // 활성화일 경우, boolean값
    }
  },
  watch: {
    val(n) {
      if(n!==undefined) this.value = n;
    },
    active(n) {
      if(n!== undefined) this.isActive = n;
    },
    isActive(n) {
      this.$emit('update:active', n);
    },
    value(n) {
      this.$emit('update:val', n);
    }
  },
  computed: {
    barStyle() {
      let style = {};

      if ( !this.isActive ) {
        style.backgroundColor = '#7ecac3';
      }
      else if ( this.isActive ) {
        if ( this.value ) {
          style.backgroundColor = '#81c8ec';
        }
        else if ( !this.value ) {
          style.backgroundColor = '#c5c5c5';
        }
      }

      return style;
    },
    pointerStyle() {
      let style = {};

      if ( !this.isActive ) {
        style.backgroundColor = '#009688';
        style.right = '-4px';
      }
      else if ( this.isActive ) {
        if ( this.value ) {
          style.backgroundColor = '#0692db';
          style.right = '-4px';
        }
        else if ( !this.value ) {
          style.backgroundColor = '#f1f1f1';
          style.left = '-4px';
        }
      }

      return style;
    }
  },
  methods: {
    toggleVal() {
      if ( this.isActive ) {
        if ( this.value ) this.value = false;
        else if ( !this.value ) this.value = true;
      }
    }
  }
}
</script>

<style lang="stylus" type="stylus" scoped>
.lp-range-bool-container
  display flex
  justify-content center
.range-bar
  width 25px
  height 10px
  position relative
  border-radius 23px
  box-shadow 1px 1px 1px #bbb
  cursor pointer
.range-pointer
  width 15px
  height 15px
  border-radius 20px
  position absolute
  top -2.5px
  box-shadow 1px 1px 1px #bbb
  cursor pointer
</style>
